export default __webpack_public_path__ + "static/background-marble-045dace0d526632de0a3adb491b00699.png";